export enum StoreLoadingEnum {
  idle = 'idle',
  pending = 'pending',
  succeeded = 'succeeded',
  failed = 'failed',
}

export interface InitialState<DATA, LOADING = StoreLoadingEnum, ERROR = Error | null> {
  loading: LOADING;
  error: ERROR;
  data: DATA;
}

export interface Error {
  code: number;
  message?: string;
  showAlert?: boolean;
}

export type QueryParams = Record<string, string | number>;

export interface LoadingState {
  isIdle: boolean;
  isPending: boolean;
  isLoaded: boolean;
}
